export function useFormattedJoinData() {
  function getFormattedJoinData(data: any, col: any): any {
    if (col.ControlType === "select" || col.ControlType === "textselect") {
      if (col.DisplayColumnName) {
        const join = "_Join_";
        const dataValue = col.ColumnNamePc;
        const key = Object.keys(data).find(
          (key) => key.includes(join) && key.includes(dataValue)
        );
        if (key) {
          return data[key];
        } else {
          return data[col.ColumnNamePc];
        }
      }
    }
    return data[col.ColumnNamePc];
  }

  return { getFormattedJoinData };
}
